import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-survey-statement-of-deficiencies-history-modal',
  templateUrl: './survey-statement-of-deficiencies-history-modal.component.html',
  styleUrls: ['./survey-statement-of-deficiencies-history-modal.component.scss']
})
export class SurveyStatementOfDeficienciesHistoryModalComponent implements OnInit{
  latestFile: any;
  previousFiles: any[];
  constructor(public dialogRef: MatDialogRef<SurveyStatementOfDeficienciesHistoryModalComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  ngOnInit() {
    this.latestFile = this.data.latestFile;
    this.previousFiles = this.data.previousFiles;
  }

  noDelete(): void {
    this.dialogRef.close({delete: false});
  }

  delete(): void {
    this.dialogRef.close({delete: true});
  }

  openFile(file: any): void {
    if (file?.filePath) {
      window.open(file.filePath, '_blank');
    }
  }

}
